import Cookies from 'cookies-js';

const REMOVED_COOKIE_PATTERNS = [
  /^ttcsid/,
  /^_tt_/,
  /^_ttp$/,
  /^AMCV_/,
  /^AMCVS_/,
  /^s_sq$/,
  /^s_cc$/,
];

export const removeUnusedCookies = (domain: string | null = '.onepeloton.com') => {
  if (!!window) {
    const cookies = document.cookie.split('; ');
    const removedCookies = cookies
      .map(c => c.split('=')[0])
      .filter(cookieName =>
        REMOVED_COOKIE_PATTERNS.some(pattern => pattern.test(cookieName)),
      );

    for (let i = 0; i < removedCookies.length; i++) {
      (Cookies as any).expire(removedCookies[i], !!domain ? { domain } : {});
    }
  }
};
